import type { SVGProps } from 'react';
const DawnFlagJP = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <path
      fill="#fff"
      d="M0 2a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
    />
    <path
      fill="#F5F5F5"
      fillRule="evenodd"
      d="M20 .5H2A1.5 1.5 0 0 0 .5 2v12A1.5 1.5 0 0 0 2 15.5h18a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 20 .5M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"
      clipRule="evenodd"
    />
    <mask
      id="dawn-flag-JP_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g mask="url(#dawn-flag-JP_svg__a)">
      <path
        fill="url(#dawn-flag-JP_svg__b)"
        fillRule="evenodd"
        d="M11 12.8c2.604 0 4.715-2.15 4.715-4.8S13.604 3.2 11 3.2 6.286 5.349 6.286 8s2.11 4.8 4.714 4.8"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <linearGradient
        id="dawn-flag-JP_svg__b"
        x1={6.286}
        x2={6.286}
        y1={3.2}
        y2={12.8}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D81441" />
        <stop offset={1} stopColor="#BB0831" />
      </linearGradient>
    </defs>
  </svg>
);
export default DawnFlagJP;
